module.exports = __webpack_public_path__ + "static/img/16.dfa8a62.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/sp/16.png
// module id = IS4a
// module chunks = 0